import { render, staticRenderFns } from "./field-select-v2.vue?vue&type=template&id=27e664da&"
import script from "./field-select-v2.vue?vue&type=script&lang=ts&"
export * from "./field-select-v2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports